import classNames from 'classnames'
import React from 'react'
import { LinkSection } from '../../types/LinkSection'
import { FooterLinkBox } from './FooterLinkBox'

export interface FooterColumnProps {
  additionalClassName?: string
  boxes: LinkSection[]
  collapsed?: boolean
  maxWidth?: string
}

export const FooterColumn = ({
  additionalClassName,
  boxes,
  collapsed = false,
  maxWidth = 'max-w-240',
}: FooterColumnProps): JSX.Element => (
  <div className={classNames(maxWidth, additionalClassName)}>
    {boxes.map((box, i) => (
      <FooterLinkBox key={i} linkSection={box} collapsed={collapsed} />
    ))}
  </div>
)
